<template>
  <div
    :class="classNames"
    v-if="loading"
  >
    <div :class="wrapperClassNames">
      <span>
        <div
          v-if="!loadingIcon"
          class="ten-loading__icon-default"
        >
          <span />
          <span />
          <span />
          <span />
        </div>
        <div
          v-else
          class="ten-loading__indicator"
        >
          <ten-icon :icon="loadingIcon" />
        </div>
      </span>
      <div
        v-if="text"
        class="ten-loading__text"
      >
        {{ this.text }}
      </div>
    </div>
    <div :class="this.loading ? 'ten-loading--blur' : ''">
      <!-- @slot content 内容 -->
      <slot />
    </div>
  </div>
  <div v-else-if="type !== 'block'">
    <slot />
  </div>
</template>

<script>
import TenIcon from '../icon';
const name = 'ten-loading';

export default {
  name,
  components: {
    TenIcon,
  },
  props: {
    /**
     * 是否加载状态
     */
    loading: {
      type: Boolean,
      default: true,
    },
    /**
     * type='block'用于容器级加载，容器需设置 position='relative'
     * @member block
     */
    type: String,
    /**
     * 加载中的文案
     */
    text: String,
    /**
     * 加载中的指示图案
     * @member icon图标列表
     */
    loadingIcon: String,
  },
  data() {
    return {
      classNames: this.getclassNames(true),
      wrapperClassNames: this.getWrapperClassName(),
    };
  },
  watch: {
    loading() {
      this.wrapperClassNames = this.getWrapperClassName();
    },
  },
  methods: {
    getclassNames() {
      return [
        name,
        {
          [`${name}--block`]: this.type === 'block',
        },
      ];
    },
    getWrapperClassName() {
      return [
        `${name}__wrapper`,
        {
          [`${name}__wrapper--hasText`]: this.text,
          [`${name}__wrapper--closed`]: !this.loading,
        },
      ];
    },
  },
};
</script>
